module.exports = __webpack_public_path__ + "img/portrait-1.fdaa0c23.png";